import { useState, useEffect } from 'react';
import apiClient from '../services/apiClient';

export const usePlanFeatures = () => {
  const [features, setFeatures] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFeatures = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get('/api/usage/features');

      // Handle both response formats
      const responseData = response.data.success ? response.data.data : response.data;

      if (responseData && responseData.features) {
        setFeatures(responseData.features);
        setError(null);
      } else {
        setError('Failed to load plan features');
      }
    } catch (err) {
      setError(err.message || 'Failed to load plan features');
      // Fail-closed on error: assume no premium features. Better to under-grant than
      // over-grant when the plan API is unreachable.
      setFeatures({
        hasAnalytics: false,
        hasCustomBranding: false,
        hasAdvancedCustomization: false,
        messagesPerMonth: 500,
        maxCharactersTotal: 25000,
        maxKnowledgeSources: 3
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFeatures();
  }, []);

  const hasFeature = (featureName) => {
    if (!features) return false;
    return features[featureName] === true;
  };

  return {
    features,
    loading,
    error,
    hasFeature,
    hasAnalytics: features?.hasAnalytics === true,
    hasCustomBranding: features?.hasCustomBranding === true,
    hasAdvancedCustomization: features?.hasAdvancedCustomization === true,
    refresh: fetchFeatures
  };
};

export default usePlanFeatures;
